import React, { Component } from "react";
import DocumentMeta from "react-document-meta";

import { AppConfig } from "app/NativeActions";

//import ReactPixel from 'react-facebook-pixel';

class Page extends Component {
  fireTracking() {
    /*  No longer needed called in Router child component <GoogleAnalytics>
    //google analytics
    ReactGA.pageview(window.location.pathname);
    //console.log(window.location.pathname);
    //hubspot
    var _hsq = (window._hsq = window._hsq || []);
    _hsq.push(["setPath", window.location.pathname]);
    _hsq.push(["trackPageView"]);

    //facebook pixel
    //ReactPixel.pageView();
    if (window.fbq) {
      window.fbq("track", "PageView");
    } */
  }

  componentDidMount() {}

  render() {
    const {
      id,
      style,
      children,
      titleTag,
      metaTitle,
      pagePath,
      metaDescription,
      metaKeywords = [],
      shareImage,
      author = null,
      contentType = "website"
    } = this.props;

    const meta = {
      title: titleTag
        ? titleTag
        : metaTitle
        ? metaTitle
        : "DealMachine for Real Estate Investing",
      description: metaDescription,
      canonical: "https://dealmachine.com/" + pagePath,
      meta: {
        charset: "utf-8",
        name: {
          author: author ? author.name : "DealMachine",

          "og:title": titleTag
            ? titleTag
            : metaTitle
            ? metaTitle
            : "DealMachine for Real Estate Investing",
          "og:description": metaDescription,
          "og:image": shareImage ? shareImage.fields.file.url : "",
          //'og:image:width': shareImage ? shareImage.fields.file.details.image.width : "",
          //'og:image:height': shareImage ? shareImage.fields.file.details.image.height : "",

          "og:url": "https://dealmachine.com/" + pagePath,

          "article:publisher": "https://www.facebook.com/dealmachineapp",

          "twitter:descriptoin": metaDescription,
          "twitter:title": titleTag,
          "twitter:image": shareImage
            ? shareImage.fields.file.url
            : "//images.ctfassets.net/tbaxdqcpgx77/49hqSYARAIEu6SWwgIiuey/3c085f0b0b9858a68ab906ba67ed845a/share_image.png",

          "twitter:card": "summary_large_image",
          "twitter:creator": author ? author.twitter : "@DealMachineApp",
          "twitter:domain": "dealmachine.com",
          "twitter:site": "@DealMachineApp",

          "og:type": contentType
          //keywords: metaKeywords
        }
      }
    };

    return (
      <DocumentMeta {...meta}>
        <div id={id} className="dm-website-page animated fadeIn" style={style}>
          {children}
        </div>
      </DocumentMeta>
    );
  }
}

export { Page };
